/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Tokens } from '../models/tokens';

/**
 * Authenticate Controller
 */
@Injectable({
  providedIn: 'root',
})
class AuthenticateControllerService extends __BaseService {
  static readonly shouldUpdateAppUsingGETPath = '/api/authenticate/shouldUpdateApp';
  static readonly tokensUsingGETPath = '/api/authenticate/tokens';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * shouldUpdateApp
   * @param params The `AuthenticateControllerService.ShouldUpdateAppUsingGETParams` containing the following parameters:
   *
   * - `app-version`: app-version
   *
   * - `app`: app
   *
   * @return OK
   */
  shouldUpdateAppUsingGETResponse(params: AuthenticateControllerService.ShouldUpdateAppUsingGETParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.appVersion != null) __headers = __headers.set('app-version', params.appVersion.toString());
    if (params.app != null) __headers = __headers.set('app', params.app.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/authenticate/shouldUpdateApp`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * shouldUpdateApp
   * @param params The `AuthenticateControllerService.ShouldUpdateAppUsingGETParams` containing the following parameters:
   *
   * - `app-version`: app-version
   *
   * - `app`: app
   *
   * @return OK
   */
  shouldUpdateAppUsingGET(params: AuthenticateControllerService.ShouldUpdateAppUsingGETParams): __Observable<boolean> {
    return this.shouldUpdateAppUsingGETResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * tokens
   * @param refreshToken refreshToken
   * @return OK
   */
  tokensUsingGETResponse(refreshToken?: string): __Observable<__StrictHttpResponse<Tokens>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (refreshToken != null) __params = __params.set('refreshToken', refreshToken.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/authenticate/tokens`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Tokens>;
      })
    );
  }
  /**
   * tokens
   * @param refreshToken refreshToken
   * @return OK
   */
  tokensUsingGET(refreshToken?: string): __Observable<Tokens> {
    return this.tokensUsingGETResponse(refreshToken).pipe(
      __map(_r => _r.body as Tokens)
    );
  }
}

module AuthenticateControllerService {

  /**
   * Parameters for shouldUpdateAppUsingGET
   */
  export interface ShouldUpdateAppUsingGETParams {

    /**
     * app-version
     */
    appVersion: string;

    /**
     * app
     */
    app: string;
  }
}

export { AuthenticateControllerService }
